import React from 'react';
import { FeatureBoardRow } from './FeatureBoardRow';

export function FeatureBoardList({
  ariaLabel,
  title,
  headerRight,
  headerTone,
  emptyTestId,
  emptyCopy,
  features = [],
  hiddenFeatureIds,
  selectedFeatureId,
  hoveredFeatureId,
  onSelectFeature,
  onHoverFeature,
  onEditFeature,
  onStartGeometryEdit,
  onDeleteFeature,
  onToggleHidden,
  onLogFill,
  now,
}) {
  return (
    <section className="feature-board-list" aria-label={ariaLabel}>
      <header className="feature-board-list__header">
        <span className="feature-board-list__title">{title}</span>
        {headerRight ? (
          <span className="feature-board-list__need" data-tone={headerTone || undefined}>
            {headerRight}
          </span>
        ) : null}
      </header>
      {features.length === 0 ? (
        <p className="feature-board-list__empty" data-testid={emptyTestId}>
          {emptyCopy}
        </p>
      ) : (
        <div className="feature-board-list__scroll">
          {features.map((feature) => (
            <FeatureBoardRow
              key={feature.id}
              feature={feature}
              hiddenFeatureIds={hiddenFeatureIds}
              selectedFeatureId={selectedFeatureId}
              hoveredFeatureId={hoveredFeatureId}
              onSelectFeature={onSelectFeature}
              onHoverFeature={onHoverFeature}
              onEditFeature={onEditFeature}
              onStartGeometryEdit={onStartGeometryEdit}
              onDeleteFeature={onDeleteFeature}
              onToggleHidden={onToggleHidden}
              onLogFill={onLogFill}
              now={now}
            />
          ))}
        </div>
      )}
    </section>
  );
}

export default FeatureBoardList;
